<template>
  <p-container>
    <p-root-portal>
      <p-dialog v-if="vm.visibleDialog && vm.appSystem" :title="vm.visibleDialog === 'create' ? $t('core.page.appSystems.createOrUpdateDialog.createTitle') : $t('core.page.appSystems.createOrUpdateDialog.updateTitle')" @close="vm.closeDialog()">
        <template #content>
          <p-row column>
            <p-text-field v-model="vm.appSystem.name" :label="$t('core.page.appSystems.createOrUpdateDialog.name')" required></p-text-field>
            <p-text-field v-model="vm.appSystem.tenantKey" :label="$t('core.page.appSystems.createOrUpdateDialog.tenantKey')" required></p-text-field>
            <p-checkbox v-model="vm.appSystem.isActive" :label="$t('core.page.appSystems.createOrUpdateDialog.isActive')"></p-checkbox>
            <div>
              <p-request-alert v-model="vm.appSystemsDataSource.error"></p-request-alert>
            </div>
          </p-row>
        </template>
        <template #actions>
          <p-button secondary @click="vm.closeDialog()">
            {{ $t('core.app.cancel') }}
          </p-button>
          <p-button @click="vm.createOrEditAppSystem()">
            {{ $t('core.app.save') }}
          </p-button>
        </template>
      </p-dialog>
    </p-root-portal>
    <h2 class="mb-4">
      {{ $t('core.page.appSystems.page.title') }}
    </h2>
    <p-request-alert v-model="vm.appSystemsDataSource.error"></p-request-alert>
    <div v-if="vm.appSystemsDataSource.data">
      <p-row>
        <p-row xs12 md6 lg2>
          <p-text-field
            v-model="vm.appSystemsDataSource.filter.searchCriteria"
            clearable
            :label="$t('core.app.search')"
            context-icon="search"
          ></p-text-field>
        </p-row>
      </p-row>
      <p-card>
        <p-surface layer="2" class="pl-2 mb-2">
          <p-row align-center>
            <p-col shrink>
              <p-button @click="vm.appSystemsDataSource.select()">
                <p-icon dense>
                  refresh
                </p-icon>
              </p-button>
              <p-button @click="vm.showCreateDialog()">
                {{ $t('core.page.appSystems.action.newAppSystem') }}
              </p-button>
            </p-col>
          </p-row>
        </p-surface>
        <p-table v-if="vm.appSystemsDataSource.data" class="appSystemList">
          <template #rows>
            <tr>
              <th>{{ $t('core.page.appSystems.list.id') }}</th>
              <th>{{ $t('core.page.appSystems.list.name') }}</th>
              <th>{{ $t('core.page.appSystems.list.tenantKey') }}</th>
              <th>{{ $t('core.page.appSystems.list.isActive') }}</th>
              <th></th>
            </tr>
            <tr v-for="appSystem in vm.appSystemsDataSource.data.items" :key="appSystem.data.id">
              <td>
                {{ appSystem.data.id }}
              </td>
              <td>
                {{ appSystem.data.name }}
              </td>
              <td>
                {{ appSystem.data.tenantKey }}
              </td>
              <td>
                {{ appSystem.data.isActive }}
              </td>
              <td>
                <p-row nowrap align-center justify-end dense>
                  <p-button
                    :disabled="vm.appSystemsDataSource.isLoading"
                    dense
                    @click="$router.push(`/_admin/${appSystem.data.id}/appSystemWebApi`)"
                  >
                    <p-icon dense>
                      settings
                    </p-icon>
                  </p-button>
                  <p-button
                    :disabled="vm.appSystemsDataSource.isLoading"
                    dense
                    @click="vm.showEditDialog(appSystem.data)"
                  >
                    <p-icon dense>
                      edit
                    </p-icon>
                  </p-button>
                  <p-button
                    :disabled="vm.appSystemsDataSource.isLoading"
                    dense
                    secondary
                    @click="vm.onDeleteClick(appSystem)"
                  >
                    <p-icon dense color="error">
                      delete
                    </p-icon>
                  </p-button>
                </p-row>
              </td>
            </tr>
          </template>
        </p-table>
        <p-pagination v-model="vm.appSystemsDataSource.paging"></p-pagination>
      </p-card>
    </div>
  </p-container>
</template>

<script lang="ts">
  import Vue from 'vue';
  import AppSystemViewModel from './list.vue.model';

  export default Vue.extend({
    auth: true,
    role: ['admin', 'hostadmin'],
    layout: 'layout-hostadmin',
    data: () => ({
      vm: new AppSystemViewModel(),
    }),
    mounted() {
      this.vm.initialize();
    },
  });
</script>
